import { getOrderById } from 'api/apollo/queries/v1/orders';
import { OrderType } from 'global-constants';
import useGetGlobalPurchaser from 'hooks/useGetGlobalPurchaser';
import useGetUserOrganization from 'hooks/useGetUserOrganization';
import { useSafeLazyQuery } from 'hooks/useSafeLazyQuery';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { triggerPrePurchaseSurvey } from 'vendor/delighted/trigger';
import { SURVEY_ORDER_OUTPUT } from '../constants';

export const useHandlePrePurchaseDelightedSurvey = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const globalPurchaser = useGetGlobalPurchaser();
  const organization = useGetUserOrganization();

  // Extract orderId from URL parameters
  const orderIdParam = searchParams?.get('orderId');

  // Ref to ensure survey is only triggered once per page load/redirect
  const surveyTriggeredRef = React.useRef(false);

  // Apollo query to fetch order by ID using parameterized query
  const [fetchOrderById, { data: orderData, loading: orderLoading, error: orderError }] = useSafeLazyQuery(
    getOrderById(SURVEY_ORDER_OUTPUT)
  );

  // Trigger survey for orders when orderId is present
  React.useEffect(() => {
    if (
      orderIdParam &&
      !surveyTriggeredRef.current &&
      globalPurchaser &&
      organization
    ) {
      // Mark as triggered to prevent multiple calls
      surveyTriggeredRef.current = true;

      // Fetch order data by ID
      fetchOrderById({
        variables: {
          id: orderIdParam
        }
      });
    }
  }, [orderIdParam, globalPurchaser, organization, fetchOrderById]);

  // Trigger survey when order data is loaded
  React.useEffect(() => {
    if (orderData?.order && globalPurchaser && organization) {
      const {order} = orderData;
      
      // Check if this is a retrieval order
      const isRetrievalOrder = order.orderType.name === 'Retrieval' || 
                              order.orderType.name === 'Bulk Retrieval' || 
                              order.orderType.name === 'Drop Retrieval';

      if (isRetrievalOrder) {
        triggerPrePurchaseSurvey(globalPurchaser, organization, {
          orderNumber: order.orderNumber,
          orderType: OrderType.RETRIEVAL,
          organization: order.organizationObject?.name || organization.name || ''
        }, dispatch);

        console.log('=== RETRIEVAL SURVEY TRIGGERED ===');
        console.log('Triggered from Orders page for retrieval order');
        console.log('Order ID:', order.id);
        console.log('Order Number:', order.orderNumber);
        console.log('Order Type:', order.orderType.name);
        console.log('==================================');
      }
    }
  }, [orderData, globalPurchaser, organization, dispatch]);

  // Handle order fetch errors
  React.useEffect(() => {
    if (orderError) {
      console.error('Failed to fetch order for survey:', orderError);
    }
  }, [orderError]);

  return {
    orderError,
    orderData
  };
}; 
